import { render, staticRenderFns } from "./detailsModel2.vue?vue&type=template&id=2f28c2af&scoped=true"
import script from "./detailsModel2.vue?vue&type=script&lang=js"
export * from "./detailsModel2.vue?vue&type=script&lang=js"
import style0 from "./detailsModel2.vue?vue&type=style&index=0&id=2f28c2af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f28c2af",
  null
  
)

export default component.exports